import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=510e79dc&scoped=true&"
import script from "./TopicList.vue?vue&type=script&lang=js&"
export * from "./TopicList.vue?vue&type=script&lang=js&"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=510e79dc&lang=less&scoped=true&"
import style1 from "./TopicList.vue?vue&type=style&index=1&id=510e79dc&lang=scss&scoped=true&"
import style2 from "./TopicList.vue?vue&type=style&index=2&id=510e79dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e79dc",
  null
  
)

export default component.exports